interface TdmLayoutProps {
  title: string;
  children?: React.ReactNode;
}

export const TdmLeftLayout = ({ children }: { children?: React.ReactNode }) => {
  return <div className='space-y-6 xl:col-start-1 xl:col-span-2'>{children}</div>;
};

export const TdmRightLayout = ({ children }: { children?: React.ReactNode }) => {
  return <div className='space-y-6 hidden xl:block xl:col-span-1'>{children}</div>;
};

export const TdmLayout = (props: TdmLayoutProps) => {
  const { title, children } = props;
  return (
    <div>
      <h3 className='text-3xl font-extrabold m-0 capitalize'>{title}</h3>
      <main className='w-full'>
        <div className='mt-8 w-full mx-auto grid grid-cols-1 gap-6 lg:grid-flow-col-dense xl:grid-cols-3'>{children}</div>
      </main>
    </div>
  );
};
